import { Injectable } from '@angular/core';
import { DatabaseService } from 'src/app/services/database/database.service';
import { Table } from 'src/model/table.model';
import { MySettings } from './my-settings.model';

@Injectable({ providedIn: 'root' })
export class MySettingsLocalService {

    private TABLE_NAME = 'my-settings';
    private table: Table;

    constructor(private databaseService: DatabaseService) {
        this.table = databaseService.getTableObject(this.TABLE_NAME);
    }

    async findAll(): Promise<MySettings[]> {
        const databaseVersion = await this.databaseService.getDbVersion();
        const objects: MySettings[] = await this.databaseService.findAll(this.table.name, databaseVersion);
        return objects;
    }

    async findOneById(id: number): Promise<MySettings> {
        const databaseVersion = await this.databaseService.getDbVersion();
        const object = await this.databaseService.findOne(id, this.table.name, databaseVersion);
        return object;
    }

    async findOneByKey(key: string): Promise<MySettings> {
        const databaseVersion = await this.databaseService.getDbVersion();
        const object = await this.databaseService.findOneByKey(key, 'myKey', this.table.name, databaseVersion);
        return object;
    }

    async save(obj: MySettings): Promise<number> {
        const databaseVersion = await this.databaseService.getDbVersion();
        const id: number = await this.databaseService.saveObject(obj, this.table.name, databaseVersion);
        return id;
    }

    async clearTable(): Promise<boolean> {
        const databaseVersion = await this.databaseService.getDbVersion();
        return this.databaseService.clearTable(this.table, databaseVersion);
    }

    async createTable(): Promise<any> {
        const databaseVersion = await this.databaseService.getDbVersion();
        this.databaseService.createTable(this.table, databaseVersion);
    }

    async update(obj: MySettings): Promise<any>{
        const databaseVersion = await this.databaseService.getDbVersion();
        return this.databaseService.updateObject(obj, this.table.name, databaseVersion);
    }
}
